import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-694c7db4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", {
    class: ["module", [ _ctx.module.type ]]
  }, [
    _createVNode("a", {
      href: _ctx.post.url,
      class: "btn read-more-btn"
    }, " Read More ", 8, ["href"])
  ], 2))
})